export const TEST_ID = 'drawControls';

export const UNDO_BUTTON_TEST_ID = 'drawControlsUndoButton';

export const REDO_BUTTON_TEST_ID = 'drawControlsRedoButton';

export const COMPLETE_BUTTON_TEST_ID = 'drawControlsCompleteButton';

export const ADD_POINT_BUTTON_TEST_ID = 'drawControlsAddPointButton';
